import qs from 'qs';

const windowReplaceState = params => {
  window.history.replaceState(
    {},
    document.title,
    `${window.location.pathname}${qs.stringify(params, { addQueryPrefix: true })}${
      window.location.hash
    }`,
  );
};

const handleQueryStringParams = () => {
  const parsedQueryString = qs.parse(window.location.search, { ignoreQueryPrefix: true });

  if (parsedQueryString.sid) {
    delete parsedQueryString.sid;
    windowReplaceState(parsedQueryString);
  }
};

export default handleQueryStringParams;
